import { sceneSeatUsageSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";

/**
 * Whether the SCENE license features should be offered for the selected workspace.
 *
 * They are only relevant for workspaces whose plan includes SCENE seats, i.e. has a `SCENE_SEAT`
 * constraint. The subscriptions they are derived from are only fetched for users that may view
 * subscription details, so this is false for everyone else.
 */
export function useAreSceneLicensesAvailable() {
  const sceneSeatUsage = useAppSelector(sceneSeatUsageSelector);
  return sceneSeatUsage !== null;
}